import angular from "angular";

angular
    .module('app')
    .service('RequestsQueue', ['$http', '$q', controller]);

function controller($http, $q) {

    function Queue() {

        let $ctrl = this;

        this.list = [];

        this.loading;

        this.finishCallback = null;

        this.setFinishCallback = function (callback) {
            $ctrl.finishCallback = callback;
        };

        this.add = function (config) {

            let defer = $q.defer();

            $ctrl.list.push({defer, config});

            if ($ctrl.list.length == 1) {
                execRequest()
            }

            return defer.promise;
        };

        this.clear = function () {
            $ctrl.list = [];
        };

        function execRequest() {

            if ($ctrl.loading) {
                return;
            }

            let req = $ctrl.list.shift();

            $ctrl.loading = true;

            $http(req.config).then(
                function (response) {
                    req.defer.resolve(response);
                    $ctrl.loading = false;
                    next();
                },
                function (error) {
                    req.defer.reject(error);
                    $ctrl.loading = false;
                    next();
                }
            );

            function next() {
                if ($ctrl.list.length) {
                    execRequest();
                } else {
                    if ($ctrl.finishCallback) {
                        $ctrl.finishCallback();
                    }
                }
            }
        }
    }

    return function () {
        return new Queue;
    };
}